import posthog from 'posthog-js';
import React from 'react';
import { parseCreatorCollectionMetafields } from '../../utils/collections';
import { ResultType } from '../Header';
import { isUserLoggedIn } from '../../utils/analytics';
import { useStore } from '../../store';
import CreatorCardContainer from '../CreatorCard';

type CreatorsDisplayProps = {
  creators: Shopify.CollectionEdge[];
  titleForTracking?: string;
  query?: string;
};

const CreatorsDisplay: React.FC<CreatorsDisplayProps> = ({
  creators,
  titleForTracking,
  query,
}: CreatorsDisplayProps) => {
  const { state } = useStore();

  return (
    <div className="mt-2 flex flex-wrap gap-7">
      {creators.map(({ node }) => {
        const { creatorLogoURL, creatorAvatarURL } = parseCreatorCollectionMetafields(node.metafields);
        const { title, handle } = node;
        return (
          <div
            key={handle}
            onClick={() => {
              if (titleForTracking === 'search') {
                posthog.capture('search_result_click', {
                  search_query: query?.trim(),
                  location: 'search_results_page',
                  is_logged_in: isUserLoggedIn(state.user),
                  result_type: ResultType.Creator,
                });
              }
            }}
            className="flex gap-3"
          >
            <CreatorCardContainer
              fullName={title}
              href={`/shop/creator/${handle}`}
              src={creatorLogoURL || creatorAvatarURL}
            />
          </div>
        );
      })}
    </div>
  );
};

export default CreatorsDisplay;
